import { useTodos } from "@/tasks/hooks";
import {
  LoadingState,
  Header,
  StatsCards,
  TaskCard,
  EmptyState,
} from "@/tasks/components";

import type { Todo } from "@/tasks/types";

const List = () => {
  const {
    data: tasks = [],
    isLoading,
    refetch,
    isError,
    error,
  } = useTodos({
    limit: 10,
  });

  if (isLoading) {
    return <LoadingState />;
  }

  if (isError) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-slate-50 via-blue-50 to-indigo-100 flex items-center justify-center">
        <div className="bg-white/80 backdrop-blur-sm rounded-2xl border border-white/20 shadow-sm p-8 max-w-md">
          <div className="text-center">
            <div className="text-red-500 text-6xl mb-4">⚠️</div>
            <h2 className="text-2xl font-bold text-gray-900 mb-2">
              Ops! Algo deu errado
            </h2>
            <p className="text-gray-600 mb-4">
              {error?.message || "Erro desconhecido ao carregar as tarefas"}
            </p>
            <button
              onClick={() => refetch()}
              className="bg-blue-600 hover:bg-blue-700 text-white px-6 py-2 rounded-lg transition-colors"
            >
              Tentar novamente
            </button>
          </div>
        </div>
      </div>
    );
  }

  const completedTasks = tasks.filter((t: Todo) => t.completed).length;
  const pendingTasks = tasks.filter((t: Todo) => !t.completed).length;

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 via-blue-50 to-indigo-100">
      <div className="container mx-auto px-4 py-8">
        <Header totalTasks={tasks.length} pendingTasks={pendingTasks} />

        <StatsCards
          totalTasks={tasks.length}
          completedTasks={completedTasks}
          pendingTasks={pendingTasks}
        />

        <div className="space-y-4">
          {tasks.map((task: Todo) => (
            <TaskCard key={task.id} task={task} />
          ))}
        </div>

        {tasks.length === 0 && <EmptyState onReload={refetch} />}
      </div>
    </div>
  );
};

export { List };
